import { connect } from 'react-redux';
import Promotion from '../../../views/Personnel/Letter/Promotion.letter.view';
import { getPromotion } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetPromotion: payload => dispatch(getPromotion(payload)),
  };
}

export default connect(null, mapDispatchToProps)(Promotion);
